import { Fragment } from 'react';
import {
  BreadcrumbContainer,
  BreadcrumbPath,
  BreadcrumbDivider
} from "./style";

const Breadcrumbs = (props) => {
  const { pathList } = props;
  const obuPathList = [{ label: 'OBU' }, ...pathList]

  return (
    <BreadcrumbContainer>
      {
        obuPathList.map((path) => <BreadcrumbPath>{path.label}</BreadcrumbPath>)
          .reduce((prev, curr) => prev === null ? [curr] : [...prev, <BreadcrumbDivider>/</BreadcrumbDivider>, curr], null)
          .map((item, index) => <Fragment key={index}>{item}</Fragment>)
      }
    </BreadcrumbContainer>
  )
}

export default Breadcrumbs;